import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useIntoleranceMutations = (patientId) => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  const invalidateIntolerances = () => {
    queryClient.invalidateQueries({ queryKey: ["intolerances"] });
    queryClient.invalidateQueries({ queryKey: ["allergies"] });
  };

  const createOrUpdateIntolerance = useMutation({
    mutationFn: async (formData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/allergy`, {
        ...formData,
        patientId: Number(patientId),
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Data saved successfully!");
      invalidateIntolerances();
    },
  });

  const deleteIntolerance = useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}/allergy/delete`, {
        data: { id },
      });
    },
    onSuccess: () => {
      toast.success("Intolerance has been deleted");
      invalidateIntolerances();
    },
  });

  const disableIntolerance = useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(`${tenantVal}/allergy/disable`, { id, disabled: true });
    },
    onSuccess: () => {
      toast.success("Intolerance has been deleted");
      invalidateIntolerances();
    },
  });

  return { createOrUpdateIntolerance, deleteIntolerance, disableIntolerance };
};
